/*
 * @Author: Zhouqi
 * @Date: 2025-12-10 10:22:39
 * @LastEditors: Zhouqi
 * @LastEditTime: 2026-01-09
 */
import dynamic from 'next/dynamic';

import ImageTranslationSkeleton from '@/3.0/image-translation/_components/image-translation-skeleton';
import DelayedRender from '@/components/DelayRender';
import { withLayout } from '@/utils/withLayout';

const ImageTranslation = dynamic(() => import('@/3.0/image-translation/entry'), {
  ssr: false,
  loading: () => (
    <DelayedRender>
      <ImageTranslationSkeleton />
    </DelayedRender>
  ),
});

const ImageTranslationPage: React.FC = () => {
  return <ImageTranslation />;
};

export default withLayout(ImageTranslationPage);
